import React, { PureComponent, Fragment } from 'react';
import { Route, Switch, Router } from 'react-router-dom';
import lazysizes from 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/respimg/ls.respimg';
import WithError from './error/withError';
import GenericError from './error/genericerror';
import cookie from "js-cookie";

import Builder from './planner/builder/builder-page';
import Itinerary from './planner/itinerary/index';
import Cookies from 'js-cookie';

const createBrowserHistory = require("history").createBrowserHistory;
const rootDataSet = document.getElementById("root").dataset;

export const history = createBrowserHistory({basename:(rootDataSet.basename !== "" )? rootDataSet.basename : ""});
const queryString = require('query-string');


class App extends PureComponent {

  componentDidMount(){

    //Scroll window to top
    window.scrollTo(0, 0);

    //Initialise image lazy loading
    lazysizes.init();

    //Set cookie from querystring
    const appIdQuery = (queryString.parse(window.location.search).affiliate_id !== undefined) ? queryString.parse(window.location.search).affiliate_id : "";
    if(appIdQuery !== "") Cookies.set('affiliate_id', appIdQuery, { expires: 30, domain: "/", hostOnly: false });

  }


  renderItineraryRoute(){
    const queryToken = queryString.parse(window.location.search);
    const token = cookie.get("ap.token");
    queryToken.t = token;
    const isShare = (token === queryToken.t && queryString.parse(window.location.search).t !== undefined) ? false : true;
    return <Itinerary share={isShare} />
  }

  renderTargetedRoute(target){
    return(
      <Router history={history} basename={rootDataSet.basename}>
        <Switch>
          { process.env.NODE_ENV !== 'production' && <Route exact path="/" component={Builder} /> }
          <Route exact path={process.env.REACT_APP_BUILDER_PAGE} component={Builder} />
          <Route exact path={process.env.REACT_APP_ITINERARY_PAGE} render={() => this.renderItineraryRoute() } />
          <Route exact path={process.env.REACT_APP_ERROR_PAGE} component={WithError(GenericError, '500')}/>
        </Switch>
      </Router>
    )
  }

  render() {

    //Appmode for matrix and standalone 
    if(rootDataSet.appmode === 'false'){
      return (
        <Fragment>
          { process.env.NODE_ENV !== 'production' && (`${(rootDataSet.target === "/" || rootDataSet.target === null) && this.renderTargetedRoute('/') }`)}
          {rootDataSet.target === `${process.env.REACT_APP_BUILDER_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_BUILDER_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_ITINERARY_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_ITINERARY_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_ERROR_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_ERROR_PAGE}`) }
        </Fragment>
      )
    }
    else{
        return (
          <Router history={history}>
            <Switch>
              { process.env.NODE_ENV !== 'production' && <Route exact path="/" component={Builder} /> }
              <Route path={process.env.REACT_APP_BUILDER_PAGE} component={Builder} />
              <Route path={process.env.REACT_APP_ITINERARY_PAGE} render={() => this.renderItineraryRoute() } />
              <Route path={process.env.REACT_APP_ERROR_PAGE} component={WithError(GenericError, '500')}/>
              <Route component={WithError(GenericError, '404')} />
            </Switch>
          </Router>
        );
    }

  }

}


export default App;
